import type { SettingDefinition, SettingsContribution } from '@repo/commons/settings'
import { createDebouncer } from '@repo/commons/utils'

export interface SettingsQueryData {
	contributionsData: SettingsContribution[]
	searchResults: (SettingDefinition & { namespace: string; displayName: string })[]
	isRefetching: boolean
	isInitialLoading: boolean
	presetsData: { id: string; name: string; description?: string }[]
}

export function useSettingsSearch() {
	let activeTab = $state<string>('ViewSettings.tabs.general')
	let searchQuery = $state('')
	let debouncedSearchQuery = $state('')

	const debounceSearch = createDebouncer(300)

	function handleSearchInput(value: string) {
		searchQuery = value
		debounceSearch(() => {
			debouncedSearchQuery = value
		})
	}

	function handleTabChange(id: string) {
		activeTab = id
	}

	return {
		get activeTab() {
			return activeTab
		},
		get searchQuery() {
			return searchQuery
		},
		get debouncedSearchQuery() {
			return debouncedSearchQuery
		},
		handleSearchInput,
		handleTabChange
	}
}
